import { or, not, and, notEmpty, readOnly } from '@ember/object/computed';
import { attr, hasMany } from '@ember-data/model';
import { isNone } from '@ember/utils';
import { computed } from '@ember/object';
import { isValidPasscode } from '@square/dashboard-data/utils/employees/passcode';
import EmberDataBaseModel from '@square/dashboard-data/models/ember-data-base-model';
export default EmberDataBaseModel.extend({
  token: readOnly('id'),
  name: attr('string'),
  // This is an array of strings
  permissions: attr('object-transform', {
    defaultValue: () => []
  }),
  // Owner roles are unique since they don't have any explicit permissions, but
  // implicitly have all permissions.
  isOwnerRole: attr('boolean', {
    defaultValue: false
  }),
  // Account owners are owners who cannot be deactivated and are not charged for.
  isAccountOwnerRole: attr('boolean', {
    defaultValue: false
  }),
  // A single Guest role can be configured for a merchant.
  isGuestRole: attr('boolean', {
    defaultValue: false
  }),
  // We explicitly specify which roles are free for billing purposes
  isFreeRole: attr('boolean', {
    defaultValue: false
  }),
  // Whether employees can use passcodes on Register
  canEmployeesAccessRegisterWithPasscode: attr('boolean', {
    defaultValue: true
  }),
  // Whether employees can use email+password to access Register.
  canEmployeesAccessMobileRegister: attr('boolean', {
    defaultValue: false
  }),
  // Whether employees can access dashboard on behalf of the merchant.
  canEmployeesAccessDashboard: attr('boolean', {
    defaultValue: false
  }),
  // Whether employees can access Appointments.
  canEmployeesAccessAppointments: attr('boolean', {
    defaultValue: false
  }),
  // Whether employees can track time from register.
  canEmployeesTrackTime: attr('boolean', {
    defaultValue: true
  }),
  managedRoles: hasMany('employee-role', {
    async: false,
    inverse: null
  }),
  canBeManaged: attr('boolean', {
    defaultValue: true
  }),
  // Only the Team Permissions role will have a passcode
  passcode: attr('string'),
  employees: hasMany('employee', {
    async: false,
    inverse: 'employeeRole'
  }),
  isPasscodeTaken: false,
  hasNoAccess: computed('canEmployeesAccessRegisterWithPasscode', 'canEmployeesAccessMobileRegister', 'canEmployeesAccessDashboard', 'canEmployeesAccessAppointments', function () {
    return !this.canEmployeesAccessRegisterWithPasscode && !this.canEmployeesAccessMobileRegister && !this.canEmployeesAccessDashboard && !this.canEmployeesAccessAppointments;
  }),
  hasValidPasscode: computed('passcode.length', function () {
    return isValidPasscode(this.passcode);
  }),
  hasPasscode: notEmpty('passcode'),
  // Whether or not a login invite can be sent to an employee.
  canInviteToLogin: or('canEmployeesAccessDashboard', 'canEmployeesAccessMobileRegister', 'canEmployeesAccessAppointments'),
  isNotOwnerRole: not('isOwnerRole'),
  isNotAccountOwnerRole: not('isAccountOwnerRole'),
  isAdminRole: and('isOwnerRole', 'isNotAccountOwnerRole'),
  isPaidRole: not('isFreeRole'),
  isPremadeRole: or('isAccountOwnerRole', 'isGuestRole'),
  revert() {
    this.rollbackAttributes();
    this.set('isPasscodeTaken', false);
  },
  canManage(otherRole) {
    if (this.isOwnerRole) {
      return true;
    }
    if (!this.permissions.includes('employee_dashboard_manage_employees')) {
      return false;
    }
    return isNone(otherRole) || this.managedRoles.includes(otherRole);
  },
  async forceClean() {
    await this.save({
      adapterOptions: {
        preventSave: true
      }
    });
  }
}).reopenClass({
  _modelNameForMigration: 'employee-role'
});